import type { FieldKeyNameMap, FieldValueTypeMap } from './types';
import { isObject } from 'lodash-es';

export function serializeValue(key: string, value: any, fieldTypesMap: FieldValueTypeMap) {
  const serializer = fieldTypesMap[key];
  return serializer ? serializer(value) : value;
}

export function serializeObjectDeep(
  obj: Record<string, any>,
  fieldKeysMap: FieldKeyNameMap,
  fieldTypesMap: FieldValueTypeMap,
): Record<string, any> {
  const result: Record<string, any> = {};

  for (const [key, value] of Object.entries(obj)) {
    const newKey = fieldKeysMap[key] ?? key;
    result[newKey]
      = isObject(value) && !Array.isArray(value) && !(value instanceof Blob)
        ? serializeObjectDeep(value, fieldKeysMap, fieldTypesMap)
        : serializeValue(newKey, value, fieldTypesMap);

    if (Array.isArray(value)) {
      result[newKey] = value.map(item =>
        isObject(item) ? serializeObjectDeep(item, fieldKeysMap, fieldTypesMap) : item,
      );
    }
  }

  return result;
}
